var OCS = OCS || {};
OCS.Viewer = OCS.Viewer || {};
OCS.Viewer.Interfaces = OCS.Viewer.Interfaces || {};
OCS.Viewer.Functions = OCS.Viewer.Functions || {};
OCS.Viewer.Functions.define_ol_lightning_style_interface = function () {
    OCS.Viewer.Interfaces.OlLightningStyle = {
        date_obj: null,
        options: {
            layer_style_ops: {mask: false},
            lightning_style_type_text: 'lightning',
            lightning_style_ops: {
                image: {
                    fill_color: 'rgba(0, 0, 0, 0.9)',
                    stroke_color: 'rgba(0, 0, 0, 0.9)',
                    stroke_width: 2,
                    type: 'RegularShape',
                    points: 4,
                    radius: 3,
                    radius2: 0,
                    angle: 0
                }
            }
        },
        get_lightning_layer_style_method: function (in_feature, res) {
            var features = in_feature.get('features');
            if(!features) {
                features = [in_feature];
            }
            var current_time = this.date_obj.get_current_epoch_time();
            var step = this.date_obj.get_animation_step()/1000;
            var minimum_display_age = step*5;
            
            var min_age = minimum_display_age;
            var shape_points = 4;
            var shape_angle = 0;
            var avg_features_strength, single_feature, timestamp, age;
            var features_strength = 0;
            var cg = false;
            if (features && features.length) {
                for (var i = 0; i < features.length; i++) {
                    single_feature = features[i];
                    timestamp = Number(single_feature.get('t'));
                    age = (current_time - timestamp)/ 1000;
                    /* istanbul ignore if */
                    if(age >= 0 && age < min_age) {
                        min_age = age;
                    }

                    features_strength += Number(single_feature.get('a'));
                    cg = single_feature.get('c');

                }
                avg_features_strength = features_strength / features.length;
            }

            /* istanbul ignore if */
            if(cg === -999 || cg === null) {
                // So if this field is missing, we are going to resolve it to the old behavior.
                cg = false;
            }
            
            if (avg_features_strength < 0) {
                shape_points = 2;
                shape_angle = Math.PI / 2;
            }

            var shape_size = avg_features_strength / 1000;
            if (shape_size < 0) {
                shape_size = shape_size * -1;
            }
            shape_size = Math.sqrt(shape_size);

            if (shape_size < 3) {
                shape_size = 3;
            }
            
            /* istanbul ignore if */
            if (shape_size > 10) {
                shape_size = 10;
            }
            var opacity = 0;
            if (min_age >= 0 && min_age <= minimum_display_age) {
                opacity = 1 - ((1/minimum_display_age) * min_age);
            }
            
            var style = [this.get_style_with_ops(this.build_style_ops(this.set_style_ops(this.options.lightning_style_ops, {
                'fill_color': 'rgba(0, 0, 0, ' + opacity + ')',
                stroke_color: 'rgba(0, 0, 0, ' + opacity + ')',
                image: {
                    'fill_color': 'rgba(0, 0, 0, ' + opacity + ')',
                    stroke_color: 'rgba(0, 0, 0, ' + opacity + ')',
                    points: shape_points,
                    radius: shape_size,
                    angle: shape_angle
                }
            })))];
            if (cg) {
                style.push(new ol.style.Style({
                    image: new ol.style.Circle({
                        radius: shape_size * 1.85,
                        fill: new ol.style.Fill({color: 'rgba(0, 0, 0, 0)'}),
                        stroke: new ol.style.Stroke({color: 'rgba(0, 0, 0, ' + opacity + ')', width: 2})
                    })
                }));
            }
            return style;
            
            
        },
        set_datetime: function(dt) {
            this.date_obj = dt;
        }
    }; // End OCS.Viewer.Interfaces.OlShapeStyle
};
OCS.Viewer.Functions.define_ol_lightning_style_interface();